import { render, staticRenderFns } from "./InformesIpaam.vue?vue&type=template&id=e2285dd8&scoped=true&"
import script from "./InformesIpaam.vue?vue&type=script&lang=js&"
export * from "./InformesIpaam.vue?vue&type=script&lang=js&"
import style0 from "./InformesIpaam.vue?vue&type=style&index=0&id=e2285dd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2285dd8",
  null
  
)

export default component.exports